/**
 * This main service that handle http request to API such as
 * - apply for pin in register page
 * - verify pin to API
 * - unregister deregister account
 * - getupcoming event
 * - get linked account
 * This service will return observe that need to subscribe to get value
 */

 import { Injectable } from '@angular/core';
 import { HttpClient, HttpHeaders } from '@angular/common/http';
 import { environment } from '../../environments/environment';
 import { catchError, map, tap } from 'rxjs/operators';
 import { NetworkService } from './network.service';
 import { StorageService } from '../services/storage.service';

 import { ControlUtils } from '../utils/controlUtils';
 import { from, throwError } from 'rxjs';

 import { SiteInfo } from '../interfaces/siteInfo';

 @Injectable({
   providedIn: 'root'
 })
 export class RemoteDataService {
   private headerOptions;

   constructor(
     private http: HttpClient,
     public netService: NetworkService,
     private controlUtils: ControlUtils,
     public storageService: StorageService) {
     const headers = new HttpHeaders();
     headers.append('Content-Type', 'application/json');
     this.headerOptions = { headers, responseType: 'json' };
   }

   // applying pin
   applyForPin(postData, ENV) {
     return this.http.post<any>(`${environment.apiHostUrls[ENV]}/applyForPin`, postData as object, {...this.headerOptions, responseType: 'text' } as Object);
   }

   /**
    * verify pin when signup/signin
    * @param pin pin number
    * @param mobileNumber mobile number current user
    * @param deviceUUID device uuid
    */
   verifyPin(pin, mobileNumber, deviceUUID, ENV) {
     const postData = {
       deviceUUID,
       mobileNumber,
       pin
     };
     return this.http.post<any>(`${environment.apiHostUrls[ENV]}/verifyPin`, postData as object, this.headerOptions as object);
   }

   refreshToken(refreshToken) {
    const ENV = this.storageService.ENV;
    return this.http.post<any>(`${environment.apiHostUrls[ENV]}/refreshToken`, {refreshToken}, this.headerOptions as object)
    .pipe((response) => {
      return response;
    }, catchError(async error => {
      if (error.status === 401) {
        await this.storageService.logout();
        await this.controlUtils.stopPresentLoading();
      } else {
        return error;
      }
    }));
  }

   /**
    * unregister device this will remove all linked and subuser account
    * @param pin pinnumber
    * @param mobileNumber mobile number curren device
    * @param deviceUUID device uuid
    */
   unregisterDevice(pin, mobileNumber, deviceUUID) {
     const postData = {
       deviceUUID,
       mobileNumber,
       pin
     };
     const ENV = this.storageService.ENV;
     return this.http.post<any>(`${environment.apiHostUrls[ENV]}/unregisterDevice`, postData as object, this.headerOptions as object);
   }

   /**
    * get all upcoming event
    * @param pin user pin
    * @param mobileNumber current mobile number
    * @param deviceUUID device uuif
    * @param deviceInfo device info from local storage
    * @param view type of view list,continous, or calendar
    * @param requestMobileNumber selected account mobile number
    */
   getupcoming(pin, mobileNumber, deviceUUID, deviceInfo, view, requestMobileNumber) {
     const postData = {
       deviceUUID,
       mobileNumber,
       pin,
       view,
       requestMobileNumber,
       deviceInfo
     };

     const ENV = this.storageService.ENV;
     if (this.netService.getStatus()) {
       return this.http.post<any>(`${environment.apiHostUrls[ENV]}/upcoming`, postData as object, this.headerOptions as object).pipe(
       map(res => {
         return res;
       }),
       tap(res => {
         this.storageService.setLocal(res, 'upcoming');
       }));
     } else {
       return from(this.storageService.getLocal('upcoming'));
     }
   }

   /**
    * get list linked account
    * @param pin user pin
    * @param mobileNumber current user mobile number
    * @param deviceUUID device uuid
    */
   getLinkedAccounts(pin, mobileNumber, deviceUUID) {
     const postData = {
       deviceUUID,
       mobileNumber,
       pin
     };

     const ENV = this.storageService.ENV;
     if (this.netService.getStatus()) {
       return this.http.post<any>(`${environment.apiHostUrls[ENV]}/linkedAccounts`, postData as object, this.headerOptions as object);
     } else {
       return from(this.storageService.getLocal('linkedAccount'));
     }
   }

   /**
    * get sub user
    * @param pin current user pin
    * @param mobileNumber current user mobile number
    * @param deviceUUID device uuid
    */
   getSubUsers(pin, mobileNumber, deviceUUID) {
     const postData = {
       deviceUUID,
       mobileNumber,
       pin
     };


     const ENV = this.storageService.ENV;
     if (this.netService.getStatus()) {
       this.headerOptions.responseType = 'json';

       return this.http.post<any>(`${environment.apiHostUrls[ENV]}/subUsers`, postData as object, this.headerOptions as object).pipe(
       map((response) => {
         return response;
       }),
       tap(response => {
         this.storageService.setLocal(response, 'subUser');
       }));
     } else {
       return from(this.storageService.getLocal('subUser'));
     }
   }

   /**
    * unlink account
    * @param pin user pin
    * @param mobileNumber user mobile number
    * @param deviceUUID device uuid
    * @param masterMobileNumber unlinked mobile number
    */
   unlinkAccount(pin, mobileNumber, deviceUUID, masterMobileNumber) {
     const postData = {
       deviceUUID,
       mobileNumber,
       pin,
       masterMobileNumber
     };

     const ENV = this.storageService.ENV;

     return this.http.post<any>(`${environment.apiHostUrls[ENV]}/unlinkAccount`, postData as object, {...this.headerOptions, responseType: 'text' } as Object);
   }

   /**
    * invite sub user
    * @param pin user pin
    * @param mobileNumber user mobile number
    * @param deviceUUID device uuid
    * @param invitedMobileNumber invited mobile number
    * @param invitedName invited name
    */
   inviteSubUser(pin, mobileNumber, deviceUUID, invitedMobileNumber, invitedName) {
     const postData = {
       deviceUUID,
       mobileNumber,
       pin,
       invitedMobileNumber,
       invitedName
     };

     const ENV = this.storageService.ENV;

     return this.http.post<any>(`${environment.apiHostUrls[ENV]}/inviteSubUser`, postData as object, {...this.headerOptions, responseType: 'text' } as Object);
   }

   /**
    * remove sub user
    * @param pin user pin
    * @param mobileNumber user mobile number
    * @param deviceUUID device uuid
    * @param invitedMobileNumber invited mobile number
    */
   removeSubUser(pin, mobileNumber, deviceUUID, invitedMobileNumber) {
     const postData = {
       deviceUUID,
       mobileNumber,
       pin,
       invitedMobileNumber
     };

     const ENV = this.storageService.ENV;
     return this.http.post<any>(`${environment.apiHostUrls[ENV]}/removeSubUser`, postData as object, {...this.headerOptions, responseType: 'text' } as Object);
   }

   getBookings(pin, mobileNumber, deviceUUID, upcomings) {
     const postData = {
       deviceUUID,
       mobileNumber,
       pin,
       upcomings
     };

     const ENV = this.storageService.ENV;
     return this.http.post<any>(`${environment.apiHostUrls[ENV]}/booking`, postData as object, this.headerOptions as object);
   }

   clearBookingMessage(pin, mobileNumber, deviceUUID, toDate, fromDate, progMode, resId) {
    const postData = {
      deviceUUID,
      mobileNumber,
      pin,
      toDate,
      fromDate,
      progMode,
      resId
    };

    const ENV = this.storageService.ENV;
    return this.http.post<any>(`${environment.apiHostUrls[ENV]}/booking/clear`, postData as object, {...this.headerOptions, responseType: 'text' } as object);
  }

  clearBookingDecline(pin, mobileNumber, deviceUUID, requestId, resId) {
    const postData = {
      deviceUUID,
      mobileNumber,
      pin,
      requestId,
      resId
    };
    const ENV = this.storageService.ENV;
    return this.http.post<any>(`${environment.apiHostUrls[ENV]}/booking/cleardecline`, postData as object,  { ...this.headerOptions, responseType: 'text' } as object);
  }

   getUtils() {
    return this.http.get(`${environment.apiHostUrls.PROD}/public/intlTelInputUtils.min.js`, { ...this.headerOptions, responseType: 'text' } as Object)
    .pipe((response) => {
      return response;
    }, catchError((err) => {
      return throwError(() => err);
    }));
   }

   getShiftStatus(postData, env?) {
     const ENV = this.storageService.ENV || env;
     return this.http.post(`${environment.apiHostUrls[ENV]}/shiftStatus`, postData as object, this.headerOptions as object);
   }

   getLocations(mobileNumber,deviceUUID, pin, sitePrefix) {
     const ENV = this.storageService.ENV;
     const postData =  { mobileNumber,deviceUUID, pin, sitePrefix };
     return this.http.post(`${environment.apiHostUrls[ENV]}/getLocations`, postData, this.headerOptions as Object)
   }

   getTransports(mobileNumber, deviceUUID, pin, sitePrefix, date, departFrom, arriveAt) {
     const ENV = this.storageService.ENV;
     const postData = {
       mobileNumber, deviceUUID, pin, sitePrefix, date, departFrom, arriveAt
     };
     return this.http.post(`${environment.apiHostUrls[ENV]}/getTransports`, postData, this.headerOptions as Object)
   }

   removeBooking(postData) {
     const ENV = this.storageService.ENV;
     return this.http.post(`${environment.apiHostUrls[ENV]}/create/remove`, postData , {...this.headerOptions, responseType: 'text' } as Object)
   }

   addBooking(postData) {
     const ENV = this.storageService.ENV;
     return this.http.post(`${environment.apiHostUrls[ENV]}/create/booking`, postData , {...this.headerOptions, responseType: 'text' } as Object)
   }

   rescheduleBooking(postData) {
     const ENV = this.storageService.ENV;
     return this.http.post(`${environment.apiHostUrls[ENV]}/create/reschedule`, postData , {...this.headerOptions, responseType: 'text' } as Object)
   }

   acknowledgeKiosk(postData) {
     const ENV = this.storageService.ENV;
     return this.http.put(`${environment.apiHostUrls[ENV]}/acknowledgeKiosk`, postData , { ...this.headerOptions, responseType: 'text' } as Object)
   }

   siteInfo(postData, env?) {
     const ENV = this.storageService.ENV || env;
     return this.http.post<SiteInfo[]>(`${environment.apiHostUrls[ENV]}/siteInfo`, postData, this.headerOptions as Object)
   }

   workflowRequestSync(postData, env?) {
     const ENV = this.storageService.ENV || env;
     return this.http.post(`${environment.apiHostUrls[ENV]}/workflowRequestsSync`, postData, this.headerOptions as Object)
   }

   getSetting(mobileNumber, deviceUUID, pin, env?) {
    const ENV = this.storageService.ENV || env;
    return this.http.
    get(`${environment.apiHostUrls[ENV]}/profileSetting/${mobileNumber}`, {
    params: {
      deviceUUID,
      pin,
    },
    ...this.headerOptions
    });
   }

   updateSetting(postData) {
     const ENV = this.storageService.ENV;
     return this.http.put(`${environment.apiHostUrls[ENV]}/profileSetting/${postData.mobileNumber}`, postData, this.headerOptions)
   }

   registerFCMToken(postData, mobileNumber, env?) {
     const ENV = this.storageService.ENV || env;
     return this.http
     .post(`${environment.apiHostUrls[ENV]}/profileFCMToken/${mobileNumber}`, postData, this.headerOptions)
   }

   unregisterFCMToken(postData) {
     const ENV = this.storageService.ENV;
     const headers = new HttpHeaders();
     headers.append('Content-Type', 'application/json');
     const headersOption = {
       headers,
     };
     const options = { body: postData, headersOption };
     return this.http.request('delete', `${environment.apiHostUrls[ENV]}/profileFCMToken`, options)
   }

   // get maintenance data
   getMaintenanceData() {
    const ENV = this.storageService.ENV || 'PROD';
    this.headerOptions.responseType = 'json';

    return this.http.get(`${environment.apiHostUrls[ENV]}/maintenance`, this.headerOptions);
  }

  cancelPendingRequest(postData) {
    const ENV = this.storageService.ENV || 'PROD';
    return this.http.post(`${environment.apiHostUrls[ENV]}/create/cancel`, postData , {...this.headerOptions, responseType: 'text' } as Object)
  }
 }
